module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAkAgMAAAAskVY5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTP///////////waf0AoAAAADdFJOUwBAwJFrSWsAAABzSURBVDjLhZPbDcAgDAPDHFm2m5XBKlEeUb/sa35PhyDYETXtCj/ZPWs3wBwdRIA5PJyih1O0cIkWLtHBLTq4RQOPaOARNSxRwxLFPJ8ooRf/IB6LF+Kn4BJ4fbh4/jL8bI4JBoyjiaHmOmCRuIJYXln7F3V1FPQn3mw7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/left.png
// module id = Qff7
// module chunks = 3